import { FormView } from '../account/form-view';
import { LinkUtil } from "../utils/link";
import { FirebaseDatabase } from "./firebase-database";
import firebase from "firebase/app";
import "firebase/auth";
import Cookies from 'js-cookie';
import constants from "../utils/constants";

export default FormView.extend({

    initialize: function(opts) {
        FormView.prototype.initialize.apply(this, [opts]);
        this.oldPasswd = this.el.querySelector("#oldPasswd");
        this.oldPasswd.value = "";
    },

    executeOperation: function() {
        return new Promise((resolve, reject) => {

            if (!this.oldPasswd.value) {
                reject(getI18N(jlocale.confirmPassword));
            }

            const authUser = firebase.auth().currentUser;
            const oldEmail = authUser.email;
            const userProvidedPassword = this.oldPasswd.value;
            const credentials = firebase.auth.EmailAuthProvider
                .credential(oldEmail, userProvidedPassword);
            
            authUser.reauthenticateWithCredential(credentials)
                .then(() => FirebaseDatabase.deleteUser(authUser.uid))
                .then(() => authUser.delete())
                .then(() => {
                    setTimeout(() => LinkUtil.goToUrl('/User/'), 1000);
                    Cookies.remove(constants.COOKIE_IS_REGISTERED);
                    resolve(getI18N(jlocale.accountdeleted));
                })
                .catch((error) => {
                    if (error.code === "auth/wrong-password") {
                        reject(getI18N(jlocale.wrongpassword));
                    } else {
                        reject(getI18N(jlocale.error));
                    }
                });
        });
    }
})